import React from 'react';
import { FAST_DEAL_LOGISTICS } from '@monorepo/dictionary';
import { SelectField, TFormField } from '@monorepo/forms';
import { enumToSelectOptions } from '@monorepo/helpers';
import { prepareOptions } from '@monorepo/ui-kit';
import { useI18n } from '@monorepo/i18n';

const LogisticsSelect = <
  TFormValues extends Record<string, any> = Record<string, any>
>(
  props: TFormField<TFormValues>
) => {
  const { t } = useI18n();

  return (
    <SelectField<TFormValues>
      options={prepareOptions(
        enumToSelectOptions(FAST_DEAL_LOGISTICS),
        t,
        'logistics.'
      )}
      {...props}
    />
  );
};

export default LogisticsSelect;
